import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "../Styles/PageTransition.css";

function PageTransition({ children }) {
  const location = useLocation();
  const [showLoader, setShowLoader] = useState(false);
  const [content, setContent] = useState(children);
  const [fadeIn, setFadeIn] = useState(true);
  const [isFirst, setIsFirst] = useState(true);

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      return;
    }

    setFadeIn(false);
    setShowLoader(true);

    const loaderTimer = setTimeout(() => {
      setContent(children);
      window.scrollTo(0, 0);
    }, 600);

    const hideTimer = setTimeout(() => {
      setShowLoader(false);
      setFadeIn(true);
    }, 1100);

    return () => {
      clearTimeout(loaderTimer);
      clearTimeout(hideTimer);
    };
  }, [location.pathname]); // eslint-disable-line

  return (
    <>
      {/* Page Loader */}
      <div className={`page-loader ${showLoader ? "page-loader-active" : ""}`}>
        <div className="page-loader-content">
          <div className="loader-logo-text">
            <span className="loader-q">Q</span>
            <span className="loader-name">Qualified Stucco</span>
          </div>
          <div className="loader-bar">
            <div className="loader-bar-fill"></div>
          </div>
          <p className="loader-tagline">Quality. Precision. Perfection.</p>
        </div>
      </div>

      {/* Page Content */}
      <div className={`page-content ${fadeIn ? "page-content-visible" : "page-content-hidden"}`}>
        {content}
      </div>
    </>
  );
}

export default PageTransition;
